import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=080551fc&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('080551fc')) {
      api.createRecord('080551fc', component.options)
    } else {
      api.reload('080551fc', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=080551fc&", function () {
      api.rerender('080551fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/layouts/Dashboard/Dashboard.vue"
export default component.exports